export const SUCCESS_USER_PROFILE = "SUCCESS_USER_PROFILE";
export const LOADING_USER_PROFILE = "LOADING_USER_PROFILE";
